"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiTextField = _interopRequireDefault(require("./HiTextField"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent HiTextField
var styles = exports.styles = function styles() {
  return {
    inputPassword: {
      fontWeight: 'bolder',
      fontFamily: 'inherit',
      letterSpacing: '4px',
      fontSize: '1.6rem'
    }
  };
};

/**
 * Champs input email pour formulaire
 */
var HiPasswordField = /*#__PURE__*/function (_React$Component) {
  function HiPasswordField(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiPasswordField);
    _this = _callSuper(this, HiPasswordField, [props]);
    _this.state = {
      showText: false
    };
    _this.handlePasswordToggle = _this.handlePasswordToggle.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiPasswordField, _React$Component);
  return (0, _createClass2.default)(HiPasswordField, [{
    key: "handlePasswordToggle",
    value: function handlePasswordToggle() {
      this.setState(function (prevState) {
        return {
          showText: !prevState.showText
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        HiInputProps = _this$props.HiInputProps,
        otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "HiInputProps"]);
      var endAdornment = this.state.showText ? 'visibility_off' : 'visibility';
      var type = this.state.showText ? 'text' : 'password';
      var inputClassName = (0, _classnames.default)((0, _defineProperty2.default)({}, classes.inputPassword, !this.state.showText && otherProps.value !== ''));
      return /*#__PURE__*/_react.default.createElement(_HiTextField.default, (0, _extends2.default)({}, otherProps, {
        type: type,
        onRightIconClick: this.handlePasswordToggle,
        HiInputProps: (0, _objectSpread2.default)({
          placeholder: '',
          maxLength: 1024
        }, HiInputProps, {
          endAdornment: endAdornment,
          inputClassName: inputClassName,
          autocomplete: 'new-password'
        })
      }));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiPasswordField'
})(HiPasswordField);